export const DEFAULT_ORIENTATION_THRESHOLD = 6;

export const resolvePdfOrientation = (columnCount, threshold = DEFAULT_ORIENTATION_THRESHOLD) => {
  const safeCount = Number(columnCount) || 0;
  return safeCount > threshold ? 'landscape' : 'portrait';
};

export default resolvePdfOrientation;
